import React from 'react';
import './About.css';

const About = () => {
  return (
    <section id="about" className="section">
      <div className="container">
        <div className="about-content">
          <div className="about-text">
            <h2 className="section-title">About Me</h2>
            <div className="about-description">
              <p>
                I'm a Solutions Architect at VAST Data with over 15 years of experience in 
                enterprise systems, automation, and infrastructure design. My expertise spans 
                datacenter implementation, automation tooling, and delivering scalable solutions 
                that drive organizational growth.
              </p>
              <p>
                Throughout my career, I've led major initiatives including automating Sales Engineer 
                lab environments, implementing enterprise VDI solutions, and managing 150+ customer 
                POCs. I specialize in Linux systems, automation tools like Ansible and Terraform, 
                and have extensive experience with VMware, Cisco, and cloud technologies.
              </p>
              <p>
                I'm passionate about leveraging cutting-edge technologies to design innovative 
                solutions while driving automation and staying at the forefront of technological 
                advancements.
              </p>
            </div>
            
            <div className="stats">
              <div className="stat">
                <h3>15+</h3>
                <p>Years Experience</p>
              </div>
              <div className="stat">
                <h3>150+</h3>
                <p>Customer POCs</p>
              </div>
              <div className="stat">
                <h3>25+</h3>
                <p>Technologies</p>
              </div>
            </div>
          </div>
          
          <div className="about-image">
            <div className="image-placeholder">
              <div className="code-icon">
                <svg viewBox="0 0 24 24" fill="currentColor">
                  <path d="M9.4 16.6L4.8 12l4.6-4.6L8 6l-6 6 6 6 1.4-1.4zm5.2 0L19.2 12l-4.6-4.6L16 6l6 6-6 6-1.4-1.4z"/>
                </svg>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;